// extracted by mini-css-extract-plugin
module.exports = {"containerProfile":"styles_containerProfile__3pXyx"};